// Web (and default) PowerSync database — WASM SQLite via @powersync/web.
// The native implementation lives in db.native.ts (Metro picks it on iOS/Android).
import { PowerSyncDatabase, WASQLiteOpenFactory } from '@powersync/web';

import { AppSchema } from './schema';

// Run SQLite and the sync stream in shared web workers so every tab of the
// origin shares one connection + database. Without this each tab opens its own
// connection, only one wins, and the others report `connected: false` (a false
// "Offline" banner) even though they still sync via the shared IndexedDB. Metro
// won't auto-bundle workers like webpack/Vite, so we point at the prebuilt
// @powersync/web bundles self-hosted under /worker/ (copied into public/ by
// scripts/copy-powersync-wasm.mjs).
const flags = { enableMultiTabs: true };

export const powerSync = new PowerSyncDatabase({
  schema: AppSchema,
  database: new WASQLiteOpenFactory({
    dbFilename: 'rbf.sqlite',
    worker: '/worker/WASQLiteDB.umd.js',
    flags,
  }),
  sync: { worker: '/worker/SharedSyncImplementation.umd.js' },
  flags,
});
